import { FF } from 'modules/feature-flags/featureFlags.generated';
import { useSplitFlag } from 'modules/feature-flags/useSplitFlag';
import { useMemo } from 'react';
import { CacheStrategy } from 'modules/viewer/PixelCacheStategy';
import { ClusterRedirect } from 'generated/graphql';
import { ViewerDownloadingFlags } from 'modules/viewer/workers/pixelDataSharedWorkerTypes';
import { useCurrentUser } from 'hooks/useCurrentUser/legacy';

export function useViewerDownloadingFlags(): [ViewerDownloadingFlags, boolean] {
  const [cacheStrategy, loadingCacheStrategy] = useSplitFlag<CacheStrategy>(
    FF.VIEWER_CACHE_STRATEGY
  );
  const { data: currentUser } = useCurrentUser();

  return useMemo(() => {
    return [
      {
        cacheStrategy,
        clusterRedirect: currentUser?.me.clusterRedirect ?? ClusterRedirect.NoRedirect,
      },
      loadingCacheStrategy || currentUser == null,
    ];
  }, [cacheStrategy, loadingCacheStrategy, currentUser]);
}
